import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  model: any = {environment: environment};

  constructor(
    public apiService: ApiService,
    private router: Router,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.loaderService.setLoaded();

    if (this.apiService.Parse.User.current()) {
      this.router.navigate(['/home']);
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/landing-page/landing-page.component.ts